import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { LucideService } from './app/shared/services/lucide.service';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    const lucideService = appRef.injector.get(LucideService);
    lucideService.initIcons(); 
  })
  .catch(console.error);